export const FormatCheckWorkflow = {
  "id": 103,
  "wfName": "Format Check",
  "wfDescription": "DATG FORMAT CHECK",
  "wide": true,
  "wfType": "FORMAT",
  "wfData": {"visible": [
    {
      "width": 9,
      "navigation_name": "Main",
      "rows": [[
          {
            "id": "series_title",
            "type": "text",
            "label": "Series Title",
            "width": 12,
            "options": { }
          }
        ], [
          {
            "id": "episode_title",
            "type": "text",
            "label": "Episode Title",
            "width": 12,
            "options": { }
          } 
        ], [
          {
            "id": "domestic_episode_number",
            "type": "text",
            "label": "Domestic Episode #",
            "width": 3,
            "options": { }
          }, {
            "id": "foreign_episode_number",
            "type": "text",
            "label": "Foreign Episode #",
            "width": 3,
            "options": { }
          }, {
            "id": "production_number",
            "type": "text",
            "label": "Production #",
            "width": 3,
            "options": { }
          }, {
            "id": "zeus_wo_number",
            "type": "text",
            "label": "ZEUS WO#",
            "width": 3,
            "options": { }
          }, 
        ]
      ]
    },
    {
      "width": 6,
      "navigation_name": "Dates",
      "rows": [[
          {
            "id": "first_air_date",
            "type": "date_history",
            "label": "First Air Date",
            "width": 2,
            "options": {
              "format": "DD MMM YYYY"
            }
          },
          {
            "id": "script_due_date",
            "type": "date_history",
            "label": "Script Due Date",
            "width": 2,
            "options": {
              "format": "DD MMM YYYY"
            }
          },
          {
            "id": "video_due_date",
            "type": "date_history",
            "label": "Video Due Date",
            "width": 2,
            "options": {
              "format": "DD MMM YYYY"
            }
          }
        ],
        [
          {
            "id": "revised_first_air_date",
            "type": "date_history",
            "label": "Revised First Air Date",
            "width": 2,
            "options": {
              "format": "DD MMM YYYY"
            }
          },
          {
            "id": "revised_script_due_date",
            "type": "date_history",
            "label": "Revised Script Due Date",
            "width": 2,
            "options": {
              "format": "DD MMM YYYY"
            }
          },
          {
            "id": "revised_video_due_date",
            "type": "date_history",
            "label": "Revised Video Due Date",
            "width": 2,
            "options": {
              "format": "DD MMM YYYY"
            }
          }
        ]
      ]
    },
    {
      "section_name": "Program Content Durations",
      "width": 6,
      "rows": [[
          {
            "id": "content_duration_ntsc_23",
            "type": "timecode",
            "label": "23.98",
            "width": 2,
            "options": {
              "frames": false
            }
          }, {
            "id": "content_duration_pal_25",
            "type": "timecode",
            "label": "PAL/25",
            "width": 2,
            "options": {
              "frames": false
            }
          }, {
            "id": "content_duration_ntsc_29",
            "type": "timecode",
            "label": "NTSC/29.97 DFTC",
            "width": 2,
            "options": {
              "frames": false
            }
          }
        ]
      ]
    },
    {
      "section_name": "Recap",
      "width": 6,
      "rows": [[
          {
            "id": "recap_voiceover",
            "type": "textarea",
            "label": "Voiceover",
            "width": 6,
            "options": { }
          }, {
            "id": "recap_duration",
            "type": "timecode",
            "label": "Duration",
            "options": {
              "frames": false
            }
          }
        ], [
          {
            "id": "recap_clips",
            "label": "",
            "type": "table",
            "width": 5,
            "options": {
              "min_value": 1,
            },
            "fields": [
              {
                "id": "clip",
                "label": "Clips",
                "type": "textarea",
                "width": 5,
                "options": { }
              }
            ]
          }
        ]
      ]
    },
    {
      "section_name": "Guest Appearances",
      "width": 6,
      "rows": [[
          {
            "id": "guest_appearances",
            "label": "",
            "type": "table",
            "width": 5,
            "options": {
              "min_value": 1,
            },
            "fields": [
              {
                "id": "actor",
                "label": "Actor/Actress",
                "type": "text",
                "width": 4,
                "options": { }
              },
              {
                "id": "character",
                "label": "Character",
                "type": "text",
                "width": 4,
                "options": { }
              }, {
                "id": "recurring",
                "label": "Recurring",
                "type": "autocomplete_select",
                "width": 1,
                "options": {
                  "data": [
                    {"displayed": "Yes", "stored": "Yes"},
                    {"displayed": "No", "stored": "No"}
                  ]
                }
              }
            ]
          }
        ]
      ]
    },
    {
      "section_name": "English Text",
      "width": 10,
      "rows": [[
        {
          "id": "english_text",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "text",
              "label": "Text",
              "type": "textarea",
              "width": 3,
              "options": {}
            }, {
              "id": "font",
              "label": "Font",
              "type": "text",
              "width": 2,
              "options": {}
            }, {
              "id": "font_size",
              "label": "Font Size",
              "type": "text",
              "width": 1,
              "options": {}
            }, {
              "id": "placement",
              "label": "Placement",
              "type": "text",
              "width": 2,
              "options": {}
            }, {
              "id": "notes",
              "type": "notes",
              "options": {}
            }, {
              "id": "disclaimers",
              "type": "select",
              "label": "",
              "width": 0,
              "options": { 
                "data": [
                  {"displayed": "English Text", "stored": "English Text"}
                ],
                "default": {"displayed": "English Text", "stored": "English Text"},
                "disclaimers": [
                  {
                    "value": "English Text",
                    "statements": [
                      "Unless otherwise noted in comments, FULL TEXTLESS is provided."
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Songs/Musical Performance/Recited Material",
      "width": 10,
      "rows": [[
        {
          "id": "songs_music_recited",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "details",
              "label": "Details",
              "type": "textarea",
              "width": 8,
              "options": {}
            }, {
              "id": "dubbing_subtitling_rights",
              "type": "autocomplete_select",
              "label": "Dubbing/Subtitling Rights",
              "width": 2,
              "options": { 
                "data": [
                  {"displayed": "Both", "stored": "Both"},
                  {"displayed": "No", "stored": "No"},
                  {"displayed": "Dubbing", "stored": "Dubbing"},
                  {"displayed": "Subtitling", "stored": "Subtitling"},
                  {"displayed": "English", "stored": "English"},
                  {"displayed": "Pending", "stored": "Pending"}
                ],
                "disclaimers": [
                  {
                    "value": "Both",
                    "statements": [
                      "We DO have foreign dubbing rights to this song.",
                      "We DO have the right to re-voice/re-record in English.",
                      "Lyrics CAN BE subtitled in ANY language.",
                      "Vocals WILL BE CLEAN from the M&E, and available in the Optional Tracks on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "No",
                    "statements": [
                      "We DO NOT have foreign dubbing rights to this song.",
                      "We DO NOT have the right to re-voice/re-record in English.",
                      "Lyrics MAY NOT BE subtitled in ANY language.",
                      "Vocals WILL BE PRESENT in the M&E on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "Dubbing",
                    "statements": [
                      "We DO have foreign dubbing rights to this song.",
                      "We DO have the right to re-voice/re-record in English.",
                      "Lyrics MAY NOT BE subtitled in ANY language.",
                      "Vocals WILL BE CLEAN from the M&E, and available in the Optional Tracks on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "Subtitling",
                    "statements": [
                      "We DO NOT have foreign dubbing rights to this song.",
                      "We DO NOT have the right to re-voice/re-record in English.",
                      "Lyrics CAN BE subtitled in ANY language.",
                      "Vocals WILL BE PRESENT in the M&E on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "English",
                    "statements": [
                      "We DO NOT have foreign dubbing rights to this song.",
                      "We DO have the right to re-voice/re-record in English.",
                      "Lyrics MAY NOT BE subtitled in ANY language.",
                      "Vocals WILL BE CLEAN from the M&E, and available in the Optional Tracks on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "Pending",
                    "statements": [
                      "***CURRENTLY PENDING LEGAL REVIEW OF RIGHTS***",
                      "Format check will be updated once we have legal confirmation of rights."
                    ]
                  }
                ]
              }
            }, {
              "id": "dubbing_notes",
              "type": "notes",
              "options": {}
            }, {
              "id": "disclaimers",
              "type": "select",
              "label": "",
              "width": 0,
              "options": { 
                "data": [
                  {"displayed": "All", "stored": "All"}
                ],
                "disclaimers": [
                  {
                    "value": "All",
                    "statements": [
                      "Please note ALL OTHER songs present in this episode are considered background/soundtrack and must remain AS-IS.",
                      "Original artist vocals will remain on the M&E.",
                      "The song lyrics for this usage MAY NOT be translated/subtitled.",
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Audio/Video Playback",
      "width": 10,
      "rows": [[
        {
          "id": "audio_video_playback",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "details",
              "label": "Details",
              "type": "textarea",
              "width": 8,
              "options": {}
            }, {
              "id": "dubbing_subtitling_rights",
              "type": "autocomplete_select",
              "label": "Dubbing/Subtitling Rights",
              "width": 2,
              "options": { 
                "data": [
                  {"displayed": "Both", "stored": "Both"},
                  {"displayed": "No", "stored": "No"},
                  {"displayed": "Dubbing", "stored": "Dubbing"},
                  {"displayed": "Subtitling", "stored": "Subtitling"},
                  {"displayed": "English", "stored": "English"},
                  {"displayed": "Pending", "stored": "Pending"}
                ],
                "disclaimers": [
                  {
                    "value": "Both",
                    "statements": [
                      "We DO have foreign dubbing rights to this song.",
                      "We DO have the right to re-voice/re-record in English.",
                      "Lyrics CAN BE subtitled in ANY language.",
                      "Vocals WILL BE CLEAN from the M&E, and available in the Optional Tracks on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "No",
                    "statements": [
                      "We DO NOT have foreign dubbing rights to this song.",
                      "We DO NOT have the right to re-voice/re-record in English.",
                      "Lyrics MAY NOT BE subtitled in ANY language.",
                      "Vocals WILL BE PRESENT in the M&E on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "Dubbing",
                    "statements": [
                      "We DO have foreign dubbing rights to this song.",
                      "We DO have the right to re-voice/re-record in English.",
                      "Lyrics MAY NOT BE subtitled in ANY language.",
                      "Vocals WILL BE CLEAN from the M&E, and available in the Optional Tracks on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "Subtitling",
                    "statements": [
                      "We DO NOT have foreign dubbing rights to this song.",
                      "We DO NOT have the right to re-voice/re-record in English.",
                      "Lyrics CAN BE subtitled in ANY language.",
                      "Vocals WILL BE PRESENT in the M&E on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "English",
                    "statements": [
                      "We DO NOT have foreign dubbing rights to this song.",
                      "We DO have the right to re-voice/re-record in English.",
                      "Lyrics MAY NOT BE subtitled in ANY language.",
                      "Vocals WILL BE CLEAN from the M&E, and available in the Optional Tracks on the Printmaster ProTools Supersession."
                    ]
                  },
                  {
                    "value": "Pending",
                    "statements": [
                      "***CURRENTLY PENDING LEGAL REVIEW OF RIGHTS***",
                      "Format check will be updated once we have legal confirmation of rights."
                    ]
                  }
                ]
              }
            }, {
              "id": "dubbing_notes",
              "type": "notes",
              "options": {}
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Unsubtitled Foreign Dialogue",
      "width": 10,
      "rows": [[
        {
          "id": "unsubtitled_foreign_dialogue",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "language",
              "label": "Language",
              "type": "text",
              "width": 3,
              "options": {}
            }, {
              "id": "details",
              "label": "Details",
              "type": "textarea",
              "width": 7,
              "options": {}
            }, {
              "id": "notes",
              "type": "notes",
              "options": {}
            }, {
              "id": "disclaimers",
              "type": "select",
              "label": "",
              "width": 0,
              "options": { 
                "data": [
                  {"displayed": "Unsubtitled Foreign Dialogue", "stored": "Unsubtitled Foreign Dialogue"}
                ],
                "default": {"displayed": "Unsubtitled Foreign Dialogue", "stored": "Unsubtitled Foreign Dialogue"},
                "disclaimers": [
                  {
                    "value": "Unsubtitled Foreign Dialogue",
                    "statements": [
                      "Lack of subtitles is CREATIVE INTENT and MUST be maintained.",
                      "Foreign dialogue will be CLEAN from the M&E and provided in the Optional Tracks of the Printmaster Pro Tools Supersession.",
                      "Full Textless is provided.",
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Subtitled Foreign Dialogue",
      "width": 10,
      "rows": [[
        {
          "id": "subtitled_foreign_dialogue",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "language",
              "label": "Language",
              "type": "text",
              "width": 2,
              "options": {}
            }, {
              "id": "details",
              "label": "Details",
              "type": "textarea",
              "width": 6,
              "options": {}
            }, {
              "id": "notes",
              "type": "notes",
              "options": {}
            }, {
              "id": "font",
              "label": "Font",
              "type": "text",
              "width": 1,
              "options": {}
            }, {
              "id": "color",
              "label": "Color",
              "type": "text",
              "width": 1,
              "options": {}
            }, {
              "id": "disclaimers",
              "type": "select",
              "label": "",
              "width": 0,
              "options": { 
                "data": [
                  {"displayed": "Subtitled Foreign Dialogue", "stored": "Subtitled Foreign Dialogue"}
                ],
                "default": {"displayed": "Subtitled Foreign Dialogue", "stored": "Subtitled Foreign Dialogue"},
                "disclaimers": [
                  {
                    "value": "Subtitled Foreign Dialogue",
                    "statements": [
                      "Foreign dialogue will be CLEAN from the M&E and provided in the Optional Tracks of the Printmaster Pro Tools Supersession.",
                      "Full Textless is provided.",
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Vocal Processing/Protools",
      "width": 10,
      "rows": [[
        {
          "id": "vocal_processing",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "recurring",
              "label": "Recurring",
              "type": "autocomplete_select",
              "width": 1,
              "options": {
                "data": [
                  {"displayed": "Yes", "stored": "Yes"},
                  {"displayed": "No", "stored": "No"}
                ]
              }
            }, {
              "id": "plugin",
              "label": "Plugin",
              "type": "text",
              "width": 3,
              "options": {}
            }, {
              "id": "details",
              "label": "Details",
              "type": "textarea",
              "width": 7,
              "options": {}
            }, {
              "id": "notes",
              "type": "notes",
              "options": {}
            }
          ]
        }
      ]]
    },
    {
      "section_name": "Censored Events",
      "width": 10,
      "rows": [[
        {
          "id": "censored_events",
          "label": "",
          "type": "table",
          "width": 10,
          "options": {
            "min_value": 1,
            "sort_by": ["timecode"]
          },
          "fields": [
            {
              "id": "timecode",
              "label": "Timecode",
              "type": "timecode",
              "options": { }
            }, {
              "id": "details",
              "label": "Details",
              "type": "textarea",
              "width": 10,
              "options": {}
            }, {
              "id": "notes",
              "type": "notes",
              "options": {}
            },
            {
              "id": "disclaimers",
              "type": "select",
              "label": "",
              "width": 0,
              "options": { 
                "data": [
                  {"displayed": "All Formats", "stored": "All Formats"}
                ],
                "default": {"displayed": "All Formats", "stored": "All Formats"},
                "disclaimers": [
                  {
                    "value": "All Formats",
                    "statements": [
                      "Please note ALL songs present in this episode are considered background/soundtrack and must remain AS-IS.",
                      "Original artist vocals will remain on the M&E",
                      "The song lyrics for this usage MAY NOT be translated/subtitled."
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]]
    },
    {
      "section_name": "General Comments",
      "width": 10,
      "rows": [[
          {
            "id": "general_comments",
            "type": "rich_text",
            "label": "Comments",
            "width": 10,
            "options": { }
          }
        ]
      ]
    }
  ]}
}


// WEBPACK FOOTER //
// ./src/app/workflows/format-check-workflow.ts